import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Location } from '@angular/common';
import { FormBuilder, FormGroup } from '@angular/forms';

import { Form } from '../../shared/form';
import { HttpErrorHandler } from '../../shared/http-error-handler';

import { Profile } from '../../_models/profile';
import { ProfileService } from '../../_services/profile.service';

@Component({
  selector: 'app-profile-change-password-form',
  templateUrl: './profile-change-password-form.component.html',
  styleUrls: ['./profile-change-password-form.component.sass'],
})
export class ProfileChangePasswordFormComponent extends Form implements OnInit {
  protected form: FormGroup;

  constructor(
    private fb: FormBuilder,
    private profileService: ProfileService,
    protected route: ActivatedRoute,
    protected router: Router,
    private location: Location,
    protected httpErrorHandler: HttpErrorHandler
  ) {
    super(route, httpErrorHandler);

    this.form = fb.group({
      old_password: [''],
      new_password: [''],
      repeat_password: [''],
    });
  }

  ngOnInit() {
    this.setFormMode('update');
    this.instance = new Profile();
  }

  protected onSubmit() {
    this.updateFlag = true;
    this.resetApiErrors(this.form);
    this.profileService.changePassword(this.instance.serialize()).subscribe(
      (instance) => {
        this.updateFlag = false;
        this.router.navigate(['dashboard/']);
      },
      (error) => this.handleError(error)
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/profile/profile-change-password-form/profile-change-password-form.component.ts